/**
 * Mobile Menu Fullscreen con Blur
 * Custom element: <mobile-menu>
 * Controla apertura/cierre, submenus expandibles, focus trap, body lock
 */

if (!customElements.get('mobile-menu')) {
  class MobileMenu extends HTMLElement {
    constructor() {
      super();
      this.menuToggle = document.querySelector('[data-menu-toggle]');
      this.menuClose = this.querySelector('[data-menu-close]');
      this.menuOverlay = this.querySelector('[data-menu-overlay]');
      this.submenuTriggers = this.querySelectorAll('[data-submenu-trigger]');
      this.scrollPos = 0;
    }

    connectedCallback() {
      /* Abrir */
      if (this.menuToggle) {
        this.menuToggle.addEventListener('click', () => this.open());
      }

      /* Cerrar — botón, overlay, ESC */
      if (this.menuClose) {
        this.menuClose.addEventListener('click', () => this.close());
      }
      if (this.menuOverlay) {
        this.menuOverlay.addEventListener('click', () => this.close());
      }
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('active')) {
          this.close();
        }
      });

      /* Submenus expandibles */
      this.submenuTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => this.toggleSubmenu(trigger));
      });

      /* Cerrar al cambiar orientación */
      window.addEventListener('orientationchange', () => {
        if (this.classList.contains('active')) this.close();
      });
    }

    open() {
      this.scrollPos = window.scrollY;
      this.classList.add('active');
      document.body.classList.add('mobile-menu-open');
      document.body.style.top = `-${this.scrollPos}px`;

      if (this.menuToggle) {
        this.menuToggle.setAttribute('aria-expanded', 'true');
      }

      this.trapFocus();
      document.dispatchEvent(new CustomEvent('mobile-menu:opened'));
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('mobile-menu-open');
      document.body.style.top = '';
      window.scrollTo(0, this.scrollPos);

      if (this.menuToggle) {
        this.menuToggle.setAttribute('aria-expanded', 'false');
      }

      this.releaseFocus();
      document.dispatchEvent(new CustomEvent('mobile-menu:closed'));
    }

    toggleSubmenu(trigger) {
      const parentItem = trigger.closest('.mobile-menu__item');
      const isExpanded = parentItem.classList.contains('expanded');

      /* Cerrar otros submenus abiertos */
      this.querySelectorAll('.mobile-menu__item.expanded').forEach(item => {
        if (item !== parentItem) item.classList.remove('expanded');
      });

      parentItem.classList.toggle('expanded');
      trigger.setAttribute('aria-expanded', !isExpanded);
    }

    trapFocus() {
      const focusable = this.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      this._focusTrap = (e) => {
        if (e.key !== 'Tab') return;
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      };

      document.addEventListener('keydown', this._focusTrap);
      setTimeout(() => first.focus(), 100);
    }

    releaseFocus() {
      if (this._focusTrap) {
        document.removeEventListener('keydown', this._focusTrap);
      }
      if (this.menuToggle) this.menuToggle.focus();
    }
  }

  customElements.define('mobile-menu', MobileMenu);
}
